export const plans = {
  title: "Wybierz plan",
  subtitle: "Cena za jednostkę miesięcznie, z rabatami ilościowymi. W jednym zamówieniu można łączyć kilka typów obiektów.",
  typeLabel: "Typ obiektu",
  types: {
    apartamento: "Apartamenty",
    hotel: "Hotel",
    camping: "Kemping",
    villa: "Wille",
  },
  units: {
    apartamento: "apartament | apartamenty | apartamentów",
    hotel: "pokój | pokoje | pokoi",
    camping: "jednostka | jednostki | jednostek",
    villa: "willa | wille | willi",
  },
  decrease: "Usuń jedną jednostkę",
  increase: "Dodaj jedną jednostkę",
  billing: {
    label: "Rozliczenie",
    monthly: "Miesięcznie",
    annual: "Rocznie",
    annualSave: "−20%",
  },
  perUnit: "/mies. za jednostkę",
  totalLine: "{qty} {units} · łącznie {total}/mies.",
  billedAnnually: "rozliczane rocznie",
  add: "Dodaj do zamówienia",
  isNew: "Nowość",
  pro: {
    badge: "Najpopularniejszy",
    tagline: "Cała platforma: AI, kanały, płatności i revenue.",
    f1: "Check-in online i automatyczne zgłaszanie gości do służb",
    f2: "Recepcja AI 24/7 na WhatsAppie: odpowiada, rozwiewa wątpliwości i automatyzuje",
    f3: "Wspólna skrzynka odbiorcza (WhatsApp + Booking, Airbnb i Expedia), tłumaczenie i przekazanie do człowieka",
    f4: "Fakturowanie elektroniczne VeriFactu",
    f5: "Channel Manager z ponad 100 OTA, wspólny kalendarz i zarządzanie stawkami (zero overbookingu)",
    f6: "Rezerwacje bezpośrednie na własnej stronie, bez prowizji",
    f7: "Inteligentne zamki z automatycznymi kodami dostępu",
    f8: "Usługi dodatkowe i upselling, przedłużenia pobytu oraz promocje",
    f9: "Płatności i obciążenia z kaucjami",
    f10: "Sprzątanie i zespół, z rolami i uprawnieniami",
    f11: "Wiele obiektów, analityka i raporty dla każdego właściciela",
  },
  suite: {
    badge: "Wszystko w cenie",
    tagline: "Najbardziej kompletny plan: telefoniczna recepcja AI, własna strona i dynamiczne ceny.",
    lead: "Wszystko z planu Pro, a dodatkowo:",
    s1: "Własny numer do WhatsAppa i połączeń",
    s2: "Telefoniczna recepcja AI: odbiera telefon 24/7 w języku gościa",
    s3: "Połączenia przychodzące: 40 min/mies. w cenie",
    s4: "WebBuilder: kompletna strona internetowa",
    s5: "Dynamiczne ceny: automatyczna korekta stawek",
    s6: "Wiele podmiotów rozliczeniowych do przypisania poszczególnym obiektom",
  },
  cart: {
    title: "Zamówienie",
    empty: "Proszę wybrać typ obiektu i liczbę jednostek, a następnie dodać plan.",
    plan: "Plan {plan}",
    remove: "Usuń",
    monthlyTotal: "Łącznie miesięcznie",
    annualTotal: "Rozliczenie roczne: {total}",
    planSwitched: "Zamówienie obejmuje jeden plan: teraz wszystko to {plan}.",
    welcomeTitle: "Zastosowano rabat z zaproszenia",
    welcomeMonthly: "{percent}% zniżki przez pierwsze {months} miesiące: {total}/mies.",
    welcomeAnnual: "Oszczędność {amount} na pierwszej fakturze rocznej",
    pay: "Przejdź do płatności",
    paying: "Otwieranie płatności…",
    taxes: "Ceny bez podatków. Stripe poprosi o dane do faktury.",
    error: "Nie udało się otworzyć płatności. Proszę spróbować ponownie.",
  },
  payment: {
    success: "Płatność otrzymana. Plan będzie aktywny za kilka sekund.",
    failed: "Płatność nie została zakończona. Można spróbować ponownie w dowolnej chwili.",
    active: "Gotowe! Plan jest aktywny.",
  },
  active: {
    includes: "Co obejmuje plan",
    discount: "Rabat z zaproszenia: {percent}% do {date}",
    discountAnnual: "Rabat z zaproszenia zastosowany na pierwszej fakturze",
    referralCredit: "Na koncie jest {amount} środków za zaproszenie innych gospodarzy: kwota zostanie odliczona od następnej faktury.",
  },
};
